/**
 * Calculator Submit Button
 *
 * Validates the parent calculator, then opens the linked modal (a
 * `modal-container` `<dialog id="modal-...">`) and hands the calculator
 * controller to the `calc-eloqua-modal` that lives inside it so the form
 * can collect results on submission.
 *
 * The Modal Link author field is the same hash format the rest of the
 * codebase uses for modal links, e.g. `#modal-calculator`.
 */
import { Component, registerComponent } from 'js/component.js';
import { openModal } from '../../../../../modal-container/clientlibs/site/js/modal-container.js';

const COMPONENT = 'calc-submit-btn';

export class CalculatorSubmitButton extends Component {
    init() {
        this.modalLink = (this.element.getAttribute('data-modal-link') || '').trim();
        this.element.addEventListener('click', (e) => this.handleClick(e));
    }

    handleClick(event) {
        event.preventDefault();

        const container = this.element.closest('.calc-container');
        const controller = container && container.calcController;
        if (!controller) return;

        if (typeof controller.validate === 'function' && !controller.validate()) {
            return;
        }

        if (!this.modalLink) {
            // eslint-disable-next-line no-console
            console.warn('Calculator Submit Button: missing Modal Link in dialog (e.g. #modal-calculator).');
            return;
        }

        const dialog = this.findDialog(this.modalLink);
        if (!dialog) {
            // eslint-disable-next-line no-console
            console.warn(`Calculator Submit Button: no <dialog> found for Modal Link "${this.modalLink}".`);
            return;
        }

        const eloquaForm = dialog.querySelector('.calc-eloqua-modal');
        if (eloquaForm && eloquaForm.calcEloquaModal && typeof eloquaForm.calcEloquaModal.setController === 'function') {
            eloquaForm.calcEloquaModal.setController(controller, dialog);
        }

        if (typeof dialog.showModal === 'function') {
            openModal(dialog);
        }
    }

    /**
     * Resolve the modal element from author input. Accepts either a hash
     * link (`#modal-foo`) or a bare modalId (`foo` → `#modal-foo`).
     */
    findDialog(link) {
        const selector = link.startsWith('#') ? link : `#modal-${link}`;
        return document.querySelector(`dialog${selector}`) || document.querySelector(selector);
    }
}

registerComponent(`.${COMPONENT}`, CalculatorSubmitButton);
